import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function FundingView() {
  useDocumentTitle('Funding-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb
        image={'bg-image-11'}
        title={'Funding Your Care'}
        link={'Funding Your Care'}
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">T</span>here are several
                  ways to pay for your care. Below are the different options for
                  funding and where you can go to get the help you need.
                </p>
                <p className="values_p3">
                  When you arrange how your care would be paid for, we would
                  discuss the creation of your personal and bespoke care service
                  with you.
                </p>
                <p className="values_p3">
                  Please get in touch with our Commercial Team.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work-with">
                        Who we work with
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/our-care">
                        Our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/excellence">
                        Quality and clinical excellence
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-values">
                        Our values
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">NHS Continuing Healthcare</h2>
                <p className="white-color">
                  Some individuals who require complex long-term care are
                  eligible for free medical care that is arranged and paid for
                  entirely by the NHS. The NHS continues to provide healthcare
                  in this way.
                </p>
                <p className="white-color">
                  NHS Continuing Healthcare is available outside of a hospital,
                  including in your house. A squad of medical experts must
                  evaluate your eligibility for NHS Continuing Healthcare. (a
                  multidisciplinary team). If it appears that you might require
                  NHS Continuing Healthcare, Integrated Care Boards, also known
                  as ICBs (the NHS organizations that contract local health
                  services), must evaluate you for it.
                </p>
                <p className="white-color">
                  For the majority of people, a preliminary checklist evaluation
                  is used to determine if you need a full assessment. Your
                  assessment can be fast-tracked if you have a terminal disease.
                </p>
                <p className="white-color">
                  You have to find your local integrated care board (ICB).
                </p>
                <p className="white-color">
                  {' '}
                  You have to find your local integrated care board (ICB).
                </p>
                <p className="white-color">
                  The team will look at all your care needs and relate them to:
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>The help you need.</li>
                    <li className="">Your complex needs.</li>
                    <li>The intensity of your needs.</li>
                    <li>
                      How unpredictable they are, including any risks to your
                      health if the right care is not provided at the right
                      time.
                    </li>
                  </ul>
                </div>
                <p className="white-color">
                  Rather than being based on a specific diagnosis or condition,
                  your eligibility for NHS Continuing Healthcare is determined
                  by your assessed requirements
                </p>
                <p className="white-color">
                  The next step, if you qualify for NHS Continuing Healthcare,
                  is to put together a care and support package that satisfies
                  your identified requirements. We would be happy to talk with
                  you about designing your own custom care service. Do not
                  hesitate to contact our Commercial Team.
                </p>
                <p className="white-color">
                  Depending on your circumstances, you may be able to benefit
                  from a variety of choices, including assistance in your home
                  and the use of a personal health budget.
                </p>
                <p className="white-color">
                  You should find out more on NHS Continuing Healthcare.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Personal Health Budget (PHB)</h2>
                <p className="">
                  A personal health budget is a sum of money set aside for your
                  health and well-being needs that have been planned and
                  approved by your local NHS team and you or your
                  representative.
                </p>
                <p>
                  A personal health budget lets you manage your healthcare and
                  support needs, such as treatments, equipment, and personal
                  care, in a way that works for you. It is for your NHS
                  healthcare and support needs. It functions similarly to
                  personal budgets, which let individuals budget for and pay for
                  their social care requirements.
                </p>
                <p>
                  Personal health budgets give you the chance to collaborate on
                  how your health and well-being needs can be best met with the
                  NHS on an equal footing. One way to control and exercise
                  choice over your healthcare is through PHB which also allows
                  you to choose your healthcare provider.
                </p>
                <p>Find out more about Personal Health Budgets.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Personal budgets and direct payments
                </h2>
                <p className="white-color">
                  If your local council determines that you are eligible for
                  assistance with any social care and support that you require,
                  you will receive an agreed-upon amount to spend through your
                  personal budget.
                </p>
                <p className="white-color">
                  One way to manage these budgets is through direct payments.
                  When you get the money to buy the agreed-upon care and support
                  you need instead of having the council arrange it for you,
                  this is called direct funding.
                </p>
                <p className="white-color">
                  You can demand an appraisal from the committee to lay out your
                  necessities. A needs assessment aids in determining: -what
                  kind of care and support you require. -How much it will cost.
                  and -what you can afford.
                </p>
                <p className="white-color">
                  The money in your personal budget can be given to you to help
                  you make more decisions about how to spend it. Direct payments
                  are what this is called.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Carers and personal budgets</h2>
                <p className="">
                  If you’re a carer, you may receive a personal budget after
                  having a carer’s assessment to see what might help make your
                  life easier.
                </p>
                <p>
                  A carer’s assessment is free and anyone over 18 can ask for
                  one.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Local Authority funding</h2>
                <p className="white-color">
                  You might be able to get your local council to cover the cost
                  of your care. How much your council will actually pay for your
                  care depends on what you need and how much you can afford.
                </p>
                <p className="white-color">
                  The first step in determining whether the local council will
                  pay for your care is for your council to conduct an assessment
                  to determine how much assistance you require. This is called a
                  needs assessment.
                </p>
                <p className="white-color">
                  Anyone can request a free needs assessment.
                </p>
                <p className="white-color">
                  The council will then conduct a financial assessment (means
                  test) to determine how much you will have to pay for care if
                  you require it.
                </p>
                <p className="white-color">The means test determines if :</p>
                <div>
                  <ul className="care_bullets">
                    <li>
                      The whole cost of your care would be covered by the
                      council.
                    </li>
                    <li className=""></li>
                    <li>The intensity of your needs.</li>
                    <li>All of your care must be paid for by you.</li>
                  </ul>
                </div>
                <p className="white-color">
                  The financial evaluation is free. You don't have to book it -
                  it will be set up for you after your requirements evaluation.
                </p>
                <p className="white-color">
                  {' '}
                  Find out more about the monetary evaluation.
                </p>
                <p className="white-color">
                  Find out when the council might be able to pay for your care.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">
                  Paying for your own care - self-funding
                </h2>
                <p className="">
                  If you are able to pay for your own care or if you are not
                  eligible for any funding from your local council, you might
                  want to pay for it yourself.
                </p>
                <p>
                  To see if you are eligible for any financial assistance, you
                  can ask for a means test or financial assessment.
                </p>
                <p>Find out more about getting a financial evaluation.</p>
                <p>
                  You can likewise decide to pay for care yourself in the event
                  that you don't need a monetary evaluation.
                </p>
                <p>
                  You can arrange and pay for care without the council's
                  involvement.
                </p>
                <p>
                  Your council can conduct an assessment to assist in
                  determining the kind of care you might require even if you
                  decide to pay for it. The term for this is a needs assessment.
                  It will tell you, for instance, whether you require paid home
                  assistance for two hours per day or two hours per week and
                  precisely what they should assist you with. Anyone can request
                  the free needs assessment. Learn more about how to get a needs
                  assessment and how to pay for your own care -self-funding.
                </p>
                <p>
                  We would be happy to talk with you about creating your own
                  personalized care service. Please contact our Commercial Team.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default FundingView;
